import React from 'react';
import styled from 'styled-components';
import Avatar from '../Avatar';

interface IProps {
  name: string;
  picture: string;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
`;

const TableUserInfoCell = ({ picture, name }: IProps) => (
  <Container>
    <Avatar picture={picture} size={20} />
    <span>{name}</span>
  </Container>
);

export default TableUserInfoCell;
